module.exports = __webpack_public_path__ + "static/img/031_TO8_1487_og.abccbf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/031_TO8_1487_og.jpg
// module id = zMAr
// module chunks = 0